import { render, staticRenderFns } from "./SectionMedia.vue?vue&type=template&id=0c866c01&"
import script from "./SectionMedia.vue?vue&type=script&lang=js&"
export * from "./SectionMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports